import ActivityCard from '../../../../Core/Activity/ActivityCard';
import Table from './Table';
const Tab2 = ({ selectedTaxAccounts ,taxId }) => {
  return (
    <div>
      <div
        className="row mb-3"
        style={{ border: "1px solid rgba(50, 50, 50, 0.35)", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Tax Rates</p>
          <Table
            selectedTaxAccounts={selectedTaxAccounts}
          />
        </div>
      </div>
      <div className="">
        <ActivityCard doctype="Item Tax Template" docname={taxId} />
      </div>
    </div>
  )
}
export default Tab2